// extracted by mini-css-extract-plugin
export default {"container":"CompliancePolicyPage_container__p5eO8"};